import { type FC, ReactNode } from 'react';

import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Options.styles';

export type ModalOptionsCardProps = {
  icon?: ReactNode;
  title: string;
  subtitle: string;
  isActive: boolean;
  cardId: string;
  onClick: () => void;
};

export const ModalOptionCard: FC<ModalOptionsCardProps> = ({
  icon,
  title,
  subtitle,
  isActive,
  cardId,
  onClick
}) => {
  const isDark = useThemeMode('dark');

  return (
    <S.OptionCard
      $isDark={isDark}
      $isCardId={cardId}
      $isActive={isActive}
      onClick={onClick}
    >
      <S.OptionCardIcon $isActive={isActive} $isDark={isDark} $cardId={cardId}>
        {icon}
      </S.OptionCardIcon>
      <S.OptionCardTitle>{title}</S.OptionCardTitle>
      <S.OptionCardSubtitle>{subtitle}</S.OptionCardSubtitle>
    </S.OptionCard>
  );
};
